export interface QldBdmRecord {
  apiName?: string;
  atsi?: string;
  bodyRemovalDate?: string;
  children?: Child[];
  coronerCaseNumber?: string;
  dateOfDisposal?: string;
  deaceasedYearOfArrivalAustralia?: DeaceasedYearOfArrivalAustralia;
  deathCertificationType?: DeathCertificationType;
  deathCertifierContactEmail?: string;
  deathCertifierContactNumber?: string;
  deathCertifierDate?: string;
  deathCertifierFamilyName?: string;
  deathCertifierFirstName?: string;
  deathCertifierMiddleNames?: string;
  deathCertifierRelationship?: string;
  deathCertifierResidenceCountry?: string;
  deathCertifierResidenceLine1?: string;
  deathCertifierResidencePostcode?: string;
  deathCertifierResidenceState?: string;
  deathCertifierResidenceSuburb?: string;
  deathDisposalType?: DeathDisposalType;
  deceasedAgeDay?: number;
  deceasedAgeDayAnyOther?: string;
  deceasedAgeHour?: string;
  deceasedAgeMinute?: string;
  deceasedAgeMonth?: number;
  deceasedAgeMonthAnyOther?: string;
  deceasedAgeSecond?: string;
  deceasedAgeYear?: number;
  deceasedAgeYearAnyOther?: string;
  deceasedAnotherTerm?: string;
  deceasedChildrenNumber?: number;
  deceasedConjugalNumber?: number;
  deceasedConjugalStatus?: string;
  deceasedDateOfBirth?: string;
  deceasedDateOfBirthKnown?: boolean;
  deceasedDateOfDeath?: string;
  deceasedDateOfDeathEnd?: string;
  deceasedDateOfDeathKnownRegistration?: DeceasedDateOfDeathKnownRegistration;
  deceasedDateOfDeathStart?: string;
  deceasedDateOfDeathUnknown?: string;
  deceasedFamilyName?: string;
  deceasedFirstName?: string;
  deceasedKnownAsFamilyName?: string;
  deceasedKnownAsFirstName?: string;
  deceasedKnownAsMiddleName?: string;
  deceasedKnownByOtherName?: boolean;
  deceasedMiddleName?: string;
  deceasedOccupation?: string;
  deceasedOccupationOther?: string;
  deceasedOneName?: boolean;
  deceasedParent1FamilyName?: string;
  deceasedParent1FirstName?: string;
  deceasedParent1Indicator?: DeceasedParentIndicator;
  deceasedParent1MaidenName?: string;
  deceasedParent1MiddleNames?: string;
  deceasedParent1Occupation?: string;
  deceasedParent1OccupationOther?: string;
  deceasedParent2FamilyName?: string;
  deceasedParent2FirstName?: string;
  deceasedParent2Indicator?: DeceasedParentIndicator;
  deceasedParent2MaidenName?: string;
  deceasedParent2MiddleNames?: string;
  deceasedParent2Occupation?: string;
  deceasedParent2OccupationOther?: string;
  deceasedPlaceOfBirthArrivalYear?: string;
  deceasedPlaceOfBirthCountry?: string;
  deceasedPlaceOfBirthKnown?: DeceasedPlaceOfBirthKnown;
  deceasedPlaceOfBirthOverseas?: boolean;
  deceasedPlaceOfBirthState?: string;
  deceasedPlaceOfBirthStateOverseas?: string;
  deceasedPlaceOfBirthSuburb?: string;
  deceasedPlaceOfDeathAgedCare?: string;
  deceasedPlaceOfDeathHospital?: string;
  deceasedPlaceOfDeathResidenceAgedCareOther?: string;
  deceasedPlaceOfDeathResidenceAgedCareOtherPostcode?: string;
  deceasedPlaceOfDeathResidenceAgedCareOtherSuburb?: string;
  deceasedPlaceOfDeathResidenceCountry?: string;
  deceasedPlaceOfDeathResidenceHospitalOther?: string;
  deceasedPlaceOfDeathResidenceHospitalOtherPostcode?: string;
  deceasedPlaceOfDeathResidenceHospitalOtherSuburb?: string;
  deceasedPlaceOfDeathResidenceLine1?: string;
  deceasedPlaceOfDeathResidenceName?: string;
  deceasedPlaceOfDeathResidenceOther?: string;
  deceasedPlaceOfDeathResidenceOtherPostcode?: string;
  deceasedPlaceOfDeathResidenceOtherSuburb?: string;
  deceasedPlaceOfDeathResidencePostcode?: string;
  deceasedPlaceOfDeathResidenceState?: string;
  deceasedPlaceOfDeathResidenceSuburb?: string;
  deceasedPlaceOfDeathType?: DeceasedPlaceOfDeathType;
  deceasedPlaceOfDisposalOverseas?: boolean;
  deceasedPlaceOfResidenceCountry?: string;
  deceasedPlaceOfResidenceLine1?: string;
  deceasedPlaceOfResidenceName?: string;
  deceasedPlaceOfResidencePostcode?: string;
  deceasedPlaceOfResidenceState?: string;
  deceasedPlaceOfResidenceSuburb?: string;
  deceasedRetired?: boolean;
  deceasedSex?: DeceasedSex;
  deceasedTimeOfBirth?: string;
  deceasedTimeOfDeath?: string;
  disposalOutsideCountry?: string;
  disposalOutsideMethod?: DisposalOutsideMethod;
  disposalOutsideMethodOther?: string;
  disposalOutsideNoticeDate?: string;
  disposalOutsideOrganisation?: string;
  disposalOutsideState?: string;
  disposalOutsideStateOverseas?: string;
  disposalOutsideSuburb?: string;
  disposalOutsideUndertaker?: string;
  electronicForm9Barcode?: string;
  orderCertificatePostType?: OrderCertificatePostType;
  orderDeathCertificate?: boolean;
  orderDeathCertificateContactEmail?: string;
  orderDeathCertificateDeliveryAddressCountry?: string;
  orderDeathCertificateDeliveryAddressLine1?: string;
  orderDeathCertificateDeliveryAddressPostcode?: string;
  orderDeathCertificateDeliveryAddressState?: string;
  orderDeathCertificateDeliveryAddressSuburb?: string;
  orderDeathCertificateDeliveryFamilyName?: string;
  orderDeathCertificateDeliveryGivenNames?: string;
  orderDeathCertificateFromOrganisation?: boolean;
  orderDeathCertificateFull?: boolean;
  orderDeathCertificateFullQuantity?: number;
  orderDeathCertificatePackage?: boolean;
  orderDeathCertificateQuantity?: number;
  relationships?: Relationship[];
  registerCertifierFirstInitial?: string;
  registerCertifierSurname?: string;
  remoteId?: string;
  remoteIdProvider?: string;
}

export interface Child {
  apiName?: string;
  childAge?: number;
  childAgeQualifier?: string;
  childDateOfBirth?: string;
  childFirstName?: string;
  childLifeStatus?: ChildLifeStatus;
  childMiddleName?: string;
  remoteId?: string;
  remoteIdProvider?: string;
}

export interface Relationship {
  apiName?: string;
  marriageAge?: number;
  marriageAgeKnown?: boolean;
  marriageAgeQualifier?: MarriageAgeQualifier;
  marriageCountry?: string;
  marriagePartnerFamilyName?: string;
  marriagePartnerFirstName?: string;
  marriagePartnerMiddleName?: string;
  marriageState?: string;
  marriageSuburb?: string;
  marriageType?: MarriageType;
  remoteId?: string;
  remoteIdProvider?: string;
}

export enum Stillborn {
  AnyOtherDeceasedPerson = 'anyOtherDeceasedPerson',
  Neonate = 'neonate',
  Stillborn = 'stillborn',
}

export enum DeceasedSex {
  AnotherTerm = 'another term',
  Female = 'female',
  Indeterminate = 'indeterminate',
  Male = 'male',
}

export enum DeceasedDateOfDeathKnownRegistration {
  Approximately = 'approximately',
  DeceasedDateOfDeathUnknown = 'deceasedDateOfDeathUnknown',
  Known = 'known',
}

export enum DeceasedParentIndicator {
  Father = 'father',
  Mother = 'mother',
  NotStated = 'notStated',
  Parent = 'parent',
  Unknown = 'unknown',
}

export enum DeceasedPlaceOfBirthKnown {
  NotStated = 'notStated',
  Unknown = 'unknown',
  Yes = 'yes',
}

export enum DeceasedPlaceOfDeathType {
  Agedcare = 'agedcare',
  Anyother = 'anyother',
  Hospital = 'hospital',
  UnknownPlace = 'unknownPlace',
}

export enum DeaceasedYearOfArrivalAustralia {
  Known = 'known',
  NotStated = 'notStated',
  Unknown = 'unknown',
}

export enum DeathDisposalType {
  Burial = 'burial',
  Cremation = 'cremation',
  OutsideQueensland = 'outsideQueensland',
  Other = 'other',
  SchoolOfAnatomy = 'schoolOfAnatomy',
}

export enum DisposalOutsideMethod {
  Burial = 'burial',
  Cremation = 'cremation',
  Other = 'other',
}

export enum OrderCertificatePostType {
  ExpressPostAustralia = 'expressPostAustralia',
  InternationalRegisteredPost = 'internationalRegisteredPost',
  RegisteredPostAustralia = 'registeredPostAustralia',
  StandardPost = 'standardPost',
}

export enum ChildLifeStatus {
  Alive = 'alive',
  Deceased = 'deceased',
  Stillborn = 'stillborn',
}

export enum MarriageType {
  DeFactoRelationship = 'de facto relationship',
  Marriage = 'marriage',
  Relationship = 'relationship',
}

export enum MarriageAgeQualifier {
  NotStated = 'notStated',
  Unknown = 'unknown',
}

export enum DeathCertificationType {
  AutopsyOrderedByCoroner = 'autopsyOrderedByCoroner',
  CauseOfDeathCertificateIssued = 'causeOfDeathCertificateIssued',
}
